//
//
//
//
//
//

export default {
  name: "RankingCell.vue",
  props: ["value"],
  computed: {
    numericValue: function() {
      if (typeof this.value === "string") {
        return parseFloat(this.value.split(" ")[0])
      }
      return this.value
    }
  }
};
